// Entende número BR digitado/colado de qualquer jeito (15/10/2026, pedido do
// Patrick: "+5511910203040", "551790901010", "(11) 97853-2515", "011 9...")
// e devolve o formato canônico 55+DDD+número. Mesma regra no app Visita
// (parseBRPhone em /opt/apk/visita-app/index.html) - mexeu aqui, mexe lá.
//
// Não confirma se o número TEM WhatsApp: a API Oficial não tem essa consulta
// (a antiga usava Baileys, que bane número). A Meta avisa sozinha na primeira
// entrega se não tiver.
const VALID_DDD = new Set([
  11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 24, 27, 28,
  31, 32, 33, 34, 35, 37, 38, 41, 42, 43, 44, 45, 46, 47, 48, 49,
  51, 53, 54, 55, 61, 62, 63, 64, 65, 66, 67, 68, 69,
  71, 73, 74, 75, 77, 79, 81, 82, 83, 84, 85, 86, 87, 88, 89,
  91, 92, 93, 94, 95, 96, 97, 98, 99,
]);

export const parseBRPhone = (raw) => {
  const text = String(raw || "").trim();
  const allDigits = text.replace(/\D/g, "");
  if (!allDigits) return { ok: false, empty: true };

  const hadLeadingZero = /^0/.test(allDigits);
  let d = allDigits.replace(/^0+/, "");
  // "0 15 11 97853-2515" (código de operadora): sobra 2 dígitos a mais na frente
  if (hadLeadingZero && !d.startsWith("55") && (d.length === 12 || d.length === 13)) {
    d = d.slice(2);
  }

  let national;
  if (d.startsWith("55") && (d.length === 12 || d.length === 13)) national = d.slice(2);
  else if (d.length === 10 || d.length === 11) national = d;
  else if (d.length < 10) {
    return { ok: false, incomplete: true, error: d.length >= 8 ? "Falta o DDD? Ex: 11 91234-5678" : "Continue digitando…" };
  } else {
    return { ok: false, error: "Número com dígitos demais." };
  }

  const ddd = national.slice(0, 2);
  let local = national.slice(2);
  if (!VALID_DDD.has(Number(ddd))) return { ok: false, error: `DDD ${ddd} não existe.` };

  let landline = false;
  let addedNine = false;
  if (local.length === 8) {
    if (/^[6-9]/.test(local)) {
      local = "9" + local; // celular antigo sem o 9 na frente
      addedNine = true;
    } else {
      landline = true;
    }
  } else if (!local.startsWith("9")) {
    return { ok: false, error: "Celular tem que começar com 9 depois do DDD." };
  }

  const number = "55" + ddd + local;
  const display = landline
    ? `+55 (${ddd}) ${local.slice(0, 4)}-${local.slice(4)}`
    : `+55 (${ddd}) ${local.slice(0, 5)}-${local.slice(5)}`;
  // Contatos antigos (wa_id da Meta) às vezes estão salvos sem o 9
  const variants = landline ? [number] : [number, "55" + ddd + local.slice(1)];
  return { ok: true, number, display, ddd, landline, addedNine, variants };
};

// Texto parece número (só dígitos/símbolos de telefone) e não nome
export const looksLikePhone = (raw) => /^[\s+()\-.\d]+$/.test(String(raw || "").trim()) && /\d{4,}/.test(String(raw).replace(/\D/g, ""));

export default parseBRPhone;
